import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/timeline/index.js
// module id = 873
// module chunks = 1